import script from "./AdminCreateCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCreateCourse.vue?vue&type=script&setup=true&lang=js"

import "./AdminCreateCourse.vue?vue&type=style&index=0&id=a754794a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a754794a"]])

export default __exports__